export default {"src":"/_next/static/media/base-color.870d0d7f.svg","height":146,"width":146,"blurWidth":0,"blurHeight":0};